import { inactiveProjectTag, isInactiveProject } from '@/lib/archived-projects';
import type { FilterOption } from '../types';

/**
 * The `projects` filter source's options: every project, archived and on-hold
 * included — an archived project still holds the hours logged against it — with
 * the inactive ones flagged, so the multi-select lists them only behind its
 * "Show archived" toggle, and tagged by their state's label. A project with no
 * status is read as active: hiding one the payload did not describe would drop
 * it without a word. [HW-951]
 */
export function projectOptions(data: unknown): FilterOption[] {
  const projectData = data as
    | { data?: Array<{ id: string; name: string; status?: string }> }
    | undefined;
  if (!projectData?.data) return [];
  return projectData.data.map((p) => {
    const inactive = p.status !== undefined && isInactiveProject(p.status);
    return {
      value: p.id,
      label: p.name,
      description: inactive && p.status ? (inactiveProjectTag(p.status) ?? undefined) : undefined,
      inactive,
    };
  });
}
